import axios from 'axios/index';
import { loaderEnd, loaderStart } from '../../actions/loader';
import {
  getAccessToken,
  getClient,
  getCurrentUser,
  isLoggedIn,
} from '../../selectors/authentication';
import { logoutRequest } from '../../actions/authentication';

export function configureApi(dispatch, getState) {
  axios.interceptors.request.use((config) => {
    // Custom config to prevent loader to be shown for a asynch request
    if (!config.hasOwnProperty('loadingDisabled') || !config.loadingDisabled) {
      dispatch(loaderStart());
    }

    let newConfig = config;
    const state = getState();
    if (isLoggedIn(state)) {
      newConfig = { ...config };
      newConfig.headers = {
        ...config.headers,
        'access-token': getAccessToken(state),
        client: getClient(state),
        'token-type': 'bearer',
        uid: getCurrentUser(state).uid,
      };
    }

    return newConfig;
  });

  axios.interceptors.response.use(
    (response) => {
      dispatch(loaderEnd());
      return response;
    },
    (error) => {
      dispatch(loaderEnd());
      let newError = error;

      if (error.response.status === 401) {
        dispatch(logoutRequest()); // Don't remember route otherwise if the user tries to login again, the same error will happen
      } else {
        if (!error.response.data.hasOwnProperty('errors')) {
          newError = {
            ...error,
            response: {
              data: {
                errors: ['An unexpector error occurred.'],
              },
            },
          };
        }
      }

      return Promise.reject(newError);
    }
  );
}



// WEBPACK FOOTER //
// ./src/services/api/api-configuration.js